export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";